/* @flow */
import { ActionTypes } from 'constants/InvitationConstants';
import { dispatcher } from 'lib/Dispatcher';
import Invitations from 'collections/Invitations';
import type { Recipient } from 'collections/Invitations';

const InvitationActions = {
  invite(groupId: Backbone$Id, recipients: Recipient[]) {
    dispatcher.dispatch({
      type: ActionTypes.CREATE_INVITATION,
      recipients,
    });

    return Invitations.invite(groupId, recipients);
  },
};

export default InvitationActions;
